var indentStyle = {"indentZero":"KTR-B","indentOne":"GMV5o","indentTwo":"MRQBc","indentThree":"dbnPs","indentFour":"RBmTq","indentFive":"Spgcc","indentSix":"keOBK"};

export { indentStyle as i };
//# sourceMappingURL=indentation-ac48921d.js.map
